import { Box } from '@mui/material';
import { Benchmark } from '@/components';
import { DefaultLayout } from '@/layouts';
import { useFetchCookies } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';

export const BenchmarkPage = () => {
  const cookiesFetched = useFetchCookies();

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout>
      <Benchmark />
    </DefaultLayout>
  );
};
